import { render } from "./invoiceDetails.vue?vue&type=template&id=6839e7a5&scoped=true"
import script from "./invoiceDetails.vue?vue&type=script&lang=js"
export * from "./invoiceDetails.vue?vue&type=script&lang=js"

import "./invoiceDetails.vue?vue&type=style&index=0&id=6839e7a5&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6839e7a5"]])

export default __exports__